module.exports = "/virtual-football/img/video/clubs/spain/real-madrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/spain/real-madrid.png
// module id = 307
// module chunks = 6